import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const BuildingIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M15.7102 14.4103C15.6669 14.1726 15.4598 14 15.2183 14H14V0.5C14 0.22388 13.7761 0 13.5 0H2.50001C2.22389 0 2.00001 0.22388 2.00001 0.5V14H0.781746C0.540166 14 0.333136 14.1726 0.289806 14.4103L0.107496 15.4103C0.0515256 15.7173 0.287366 16 0.599436 16H6.6667V13.1545C6.6667 12.5168 7.18367 12 7.82136 12H8.17866C8.81636 12 9.33332 12.5169 9.33332 13.1545V16H15.4006C15.7126 16 15.9485 15.7173 15.8925 15.4103L15.7102 14.4103ZM7.00001 9H4.00001V7H7.00001V9ZM7.00001 5H4.00001V3H7.00001V5ZM12 9H9.00001V7H12V9ZM12 5H9.00001V3H12V5Z" })));
};

export { BuildingIcon };
//# sourceMappingURL=BuildingIcon.esm.js.map
